<script>
import $ from 'jquery';

export default {
    render() {
        return this.$scopedSlots.default();
    },

    mounted() {
        $(this.$el).slick({
            centerPadding: 0,
            dots: true,
            prevArrow: `<svg class="carousel__previous" width="30" height="50" viewBox="0 0 30 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M28.9 6.30001L11.5 23.1C10.4 24.2 10.4 25.9 11.5 27L28.9 43.8C30 44.9 30 46.6 28.9 47.7L27.8 48.8C26.7 49.9 24.9 49.9 23.8 48.8L4.3 30L1.1 27C1.49012e-06 25.9 1.49012e-06 24.2 1.1 23.1L4.3 20.1L23.7 1.30001C24.8 0.200006 26.6 0.200006 27.7 1.30001L28.8 2.40001C30 3.50001 30 5.20001 28.9 6.30001Z" fill="white"/></svg>`,
            nextArrow: `<svg class="carousel__next" width="30" height="50" viewBox="0 0 30 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.10002 6.30001L18.5 23.1C19.6 24.2 19.6 25.9 18.5 27L1.10002 43.7C2.43783e-05 44.8 2.43783e-05 46.5 1.10002 47.6L2.20002 48.7C3.30002 49.8 5.10002 49.8 6.20002 48.7L25.7 30L28.9 27C30 25.9 30 24.2 28.9 23.1L25.7 20.1L6.30002 1.30001C5.20002 0.200006 3.40002 0.200006 2.30002 1.30001L1.10002 2.40001C2.43783e-05 3.50001 2.43783e-05 5.20001 1.10002 6.30001Z" fill="white"/></svg>`,
        });
    },
};
</script>
